@if (edittedArea) {
  <a class="back-button" (click)="back()">
    <svg class="arrow" alt="Arrow" xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9">
      <g id="arrow_-foward_-go_-right" data-name="arrow,-foward,-go,-right" transform="translate(-1 -8.293)">
        <path id="Path" d="M13.547,8.293,18,12.793l-4.453,4.5-.817-.826,3.057-3.09H1V12.209H15.787l-3.057-3.09Z"
          transform="translate(0 0)" class="fi-fill-brand-primary-default"/>
      </g>
    </svg>
    <span fiTranslation="BUTTON_BACK"></span>
  </a>
}
<div class="container">
  @if (!edittedArea && areas.length) {
    <h2 class="main-title"><span fiTranslation="ADMINISTRATION_AREA_OVERVIEW"></span> {{ mandant?.Name }}</h2>
    <div class="main-form">
      <div class="field search">
        <div class="select-type select input-field">
          <img src="assets/icons/search.svg" alt="search" class="search-icon-custom">
          <input maxlength="500" #searchInput type="text" class="select-input-custom" fiTranslation="SEARCH_PLACEHOLDER" [isPLaceHolder]="true">
        </div>
      </div>
    </div>
    <h3 class="list-title"><span fiTranslation="ADMINISTRATION_AREA_MANDANT"></span> {{ mandant?.Name }}</h3>
    <div class="area-list">
      @for (area of areas; track area; let i = $index) {
        @if ((area.Description + area.Number)?.toLowerCase().includes(searchInput.value.toLowerCase())) {
          <div class="item">
            <span class="name"> {{ area.Description }} {{ area.Number }} </span>
            @if (employees) {
              <button (click)="onEdit(i)"
                #edit [isTitle]="true"
                fiTranslation="ADMINISTRATION_EDIT" matTooltip="{{edit.dataset.matTooltip}}"
                matTooltipPosition="below" matTooltipClass='tooltip-style'
                >
                <img class="edit" alt="Edit" src="assets/icons/edit.svg">
                <span class="u-hidden-visually" fiTranslation="ADMINISTRATION_EDIT"></span>
              </button>
              <button (click)="onDelete(i)"
                #delete [isTitle]="true"
                fiTranslation="ADMINISTRATION_DELETE" matTooltip="{{delete.dataset.matTooltip}}"
                matTooltipPosition="below" matTooltipClass='tooltip-style'
                >
                <img class="close" alt="Delete" src="assets/icons/close-icon.svg">
                <span class="u-hidden-visually" fiTranslation="ADMINISTRATION_DELETE"></span>
              </button>
            }
          </div>
        }
      }
    </div>
  }

  @if (employees && mandant && !edittedArea) {
    <button class="new-btn" (click)="onCreate()">
      <img alt="Add org unit setting" src="/assets/icons/add-area.svg">
      <span fiTranslation="ADMINISTRATION_AREA_CREATE"></span>
    </button>
  }

  @if (edittedArea) {
    <div class="edit-container">
      <span class="mandatory-text" fiTranslation="FORM_ERRORMSG_HEADLINE_MANDATORY_FIELDS"></span>
      <h2 class="edit-title"><span [fiTranslation]="edditedIndex >= 0 ? 'ADMINISTRATION_AREA_EDIT' : 'ADMINISTRATION_AREA_CREATE'"></span></h2>
      <div class="main-form margin">
        <div class="field">
          <p class="label-text">
            <span fiTranslation="ADMINISTRATION_AREA_DESCRIPTION"></span>
          </p>
          <input maxlength="500" fiTranslation="ADMINISTRATION_AREA_DESCRIPTION" [isPLaceHolder]="true" type="text" class="input-field first" [(ngModel)]="edittedArea.Description" [class.empty-field]="descriptionError" (change)="descriptionError = false">
          <input maxlength="500" fiTranslation="ADMINISTRATION_AREA_NUMBER" [isPLaceHolder]="true" type="number" min="0" max="9999" step="1" class="input-field last" [(ngModel)]="edittedArea.Number" [class.empty-field]="numberError" (change)="numberError = false">
        </div>
        <div class="field">
          <p class="label-text">
            <span fiTranslation="ADMINISTRATION_AREA_RESPONSIBLE_USER"></span>
          </p>
          <div fiCustomSelect
            (value)="onUsersChanged($event)"
            [data]="employees"
            [isMultiSelect]="true"
            [selectedData]="selectedUsers"
            [placeHolder]="selectedUsersText"
            [dataValueKey]="'Id'"
            [dataNameKey]="'FullName'"
            class="select-type select input-field">
            <span class="selected-value placeholder"></span>
            <img src="assets/icons/arrow-down-dark.svg" alt="icon" class="arrow">
            <div class="options-cont large">
              <ul class="options"></ul>
            </div>
          </div>
          @if (selectedUsers?.length) {
            <button [isTitle]="true" fiTranslation="ADMINISTRATION_AREA_DELETE" matTooltip="{{clear.dataset.matTooltip}}"
              matTooltipPosition="below" matTooltipClass='tooltip-style' #clear class="clear-dropdown" (click)="onClearUsers()"><img class="close" alt="Delete" src="assets/icons/close-icon.svg">
              <span class="u-hidden-visually" fiTranslation="ADMINISTRATION_AREA_DELETE"></span>
            </button>
            }
          </div>
        </div>
        <div class="footer">
          <button class="submit-btn" (click)="onSubmit()" [class.edit]="edditedIndex >= 0">
            @if (edditedIndex >= 0) {
              <img alt="Save" src="assets/icons/save-blue.svg">
            }
            @if (!(edditedIndex >= 0)) {
              <img alt="Save" src="assets/icons/add-area-white.svg">
            }
            <span [fiTranslation]="edditedIndex >= 0 ? 'ADMINISTRATION_SAVE_CHANGES' : 'ADMINISTRATION_AREA_BUTTON_CONFIRM_CREATION'"></span>
          </button>
        </div>
      </div>
    }
  </div>


